import React from 'react';
import { Page as Component } from '~/components/specifics/vendors/deals/[id]/completion_reports/Page';

export const Page: React.FC = () => <Component />;
